import { IdType, UserType } from "src/types"
import { crudAxios as axios } from "src/utils/axios"

import { ResponseWrapper } from "./types"

export const deleteUser = (userID: IdType) =>
  axios.delete<ResponseWrapper<string>>(`/user/${userID}`)

export const getUser = () => axios.get<ResponseWrapper<UserType[]>>("/user")
